<template>
    <v-col style="font-family: 'Avenir', sans-serif !important;">
        <v-card class="mx-auto pa-5"
            max-width="400" outlined>
            <v-icon class="d-flex justify-center" :color="information.color" x-large>{{ information.icon }}</v-icon>
            <v-chip :color="information.color" class="d-flex my-4 py-7 justify-center" text-color="white" label>
                <v-card-title class="font-weight-bold" >{{ getPlanName() }}</v-card-title>
            </v-chip>
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="d-flex justify-center">
                        <span class="title font-weight-bold">{{ information.currency }}</span>
                        <span class="display-3 font-weight-bold">{{ information.price }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="d-flex justify-center">
                        <span class="subheading">{{ getPeriodicity() }}</span>
                        <v-divider class="mx-2 my-0" inset vertical></v-divider>
                        <span class="subheading">{{ getBilled() }}</span>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <div v-if="highlighted">
                <div v-bind:key="prop.item" v-for="(prop, index) in properties">
                    <div v-if="index < rederedSize">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon v-if="prop.isPro && information.planName === 'BASIC'" small>fa-grip-lines</v-icon>
                                <v-icon v-else small>fa-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title v-if="prop.isPro && information.planName === 'BASIC'" v-html="prop.basicItem"/>
                            <v-list-item-title v-else v-html="prop.item"/>
                        </v-list-item>
                        <v-divider class="mx-4"></v-divider>
                    </div>
                </div>
            </div>
            <div v-if="rederedSize !== properties.length && highlighted !== false" class="d-flex mb-3 mt-7 justify-center">
                <v-btn class="my-2" @click="readMorePlanInformation" plain> {{ $t('readMore') }} </v-btn>
            </div>
            <div class="d-flex flex-column mb-3 mt-7 justify-center">
                <!-- Depay Button!-->
                <v-btn class="depay-button mb-5 mt-1 py-5" @click="payWithDepay">{{ $t('payWithCrypto') }} »</v-btn>

                <!--ePayco Button!-->
                <!-- <v-btn v-if="information.planName !== 'BASIC' && !information.planName.toLowerCase().startsWith('lifetime') && this.$store.state.user.details.country === 'Colombia'" :class="(information.planName.startsWith('ANNUALLY'))? 'special-button py-5' : 'ml-0 py-5'" @click="payNow">
                    {{ $t('payWithEPayco') }} »
                </v-btn> -->

                <!-- Paypal Button!-->
                <!-- <div v-else-if="information.planName !== 'BASIC' && this.$store.state.user.details.country !== 'Colombia'" class="paypal-button-container"></div> -->

                <!-- Stripe Button!-->
                <v-btn class="mb-5 mt-4 py-5" v-if="information.planName !== 'BASIC'"  @click="payWithStripe">
                    {{ $t('payWithCreditCard') }} »
                </v-btn>
            </div>
        </v-card>
    </v-col>
</template>

<script>
    import Repository from '../../repositories/subscription';
    import { loadStripe } from '@stripe/stripe-js';
    import DepayRepository from '../../repositories/depay';
    import DePayWidgets from '@depay/widgets';

    export default {
        name: "PlanCard",
        props: {
            information: Object,
            properties: Array,
            couponName: String,
            highlighted: Boolean,
        },
        data() {
            return {
                stripe: null,
                stripeSession: null,
                rederedSize: 5,
            };
        },
        methods: {
            getPlanName(){
                if(this.information.planName==='Monthly Pro'){
                    return this.$t('monthlyPro');
                }else if(this.information.planName==='Annually Pro'){
                    return this.$t('annuallyPro');
                }else if(this.information.planName==='Lifetime Pro'){
                    return this.$t('lifetimePro');
                }else if(this.information.planName==='BASIC'){
                    return this.$t('basic');
                }
            },
            getPeriodicity(){
                if(this.information.periodicity==='Per month'){
                    return this.$t('perMonth')
                }else if(this.information.periodicity==='Forever'){
                    return this.$t('forever')
                }
            },
            getBilled(){
                if(this.information.billed==='Billed monthly'){
                    return this.$t('billedMonthly')
                }else if(this.information.billed==='Billed yearly'){
                    return this.$t('billedYearly')
                }else if(this.information.billed==='Lifetime'){
                    return this.$t('lifetime')
                }
            },
            readMorePlanInformation() {
                this.rederedSize = this.properties.length;
            },
            async payWithDepay() {
                Repository.purchaseAttempt();
                let accepts = await DepayRepository.getDepayAccepts()
                let acceptsWithAmounts = accepts.data.map((a) => {
                    let months = this.information.billed=='Billed yearly'?12:1 // lifetime or monthly
                    a.amount = Number(this.information.price) * months
                    return a
                })
                DePayWidgets.Payment({
                    accept: acceptsWithAmounts,
                    track: {
                        method: async (payment) => {
                            payment.planId = this.information.planId
                            await DepayRepository.trackPayment(payment)
                        },
                        poll: {
                            method: async (payment)=> {
                                let response = await DepayRepository.pollDepayPaymentStatus(payment)
                                return response
                            }
                        }
                    },
                    succeeded: () => {
                        this.$emit('successfulPayment');
                    }
                });
            },
            async payWithStripe() {
                Repository.purchaseAttempt();
                if(this.information.planName !== 'BASIC') {
                    this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
                    let sessionConfig = {
                        userId: this.$store.state.user.id,
                        swisetPlan: (this.information.planName.toUpperCase().includes('ANNUALLY'))? 'ANNUALLY_PRO' : 'LIFETIME_PRO',
                        partnerShortName: this.$store.state.whitelabel.partner !== null ? this.$store.state.whitelabel.partner.shortName : 'Swiset'
                        //price: (this.information.planName.toUpperCase().includes('ANNUALLY'))? this.information.price * 12 : this.information.price
                    };
                    if(this.couponName !== '')
                        sessionConfig.couponName = this.couponName;

                    await Repository.createStripeSession(sessionConfig).then((response) => {
                        if (response.status < 400)
                            this.stripeSession = response.data;
                    });
                    await this.stripe.redirectToCheckout({
                        sessionId: this.stripeSession.sessionId,
                    });
                }
            },
            payNow() {
                Repository.purchaseAttempt();
                this.$emit('payNow', this.information);
            }
        }
    }
</script>

<style scoped>
    .special-border-color {
        border: 2px solid #00abff !important;
    }

    .special-button {
        border: 2px solid #00abff !important;
    }

    .special-button:hover {
        border: 2px solid #00abff !important;
        background-color: #00abff !important;
        color: #ffffff !important;
    }

    .depay-button {
        border: 1px solid #FF5722 !important;
    }

    .depay-button:hover {
        border: 1px solid #FF5722 !important;
        background-color: #FF5722 !important;
        color: #ffffff !important;
    }


</style>


